var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section full-height"},[_vm._v("\n  "+_vm._s(_vm.$t('Tu plan ha caducado'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }